import { type ReactNode } from "react";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import Input from "./ui/input";
import Button from "./ui/button";

const emailSchema = z.object({
	email: z.string().email("Please enter valid email address"),
});

type EmailFormData = z.infer<typeof emailSchema>;

interface EmailFormProps {
	onSubmit: (data: EmailFormData) => void;
	isLoading?: boolean;
	error?: string | null;
	defaultEmail?: string;
	badge?: ReactNode;
	buttonLabel?: string;
}

export default function EmailForm({ onSubmit, isLoading = false, error, defaultEmail, badge, buttonLabel = "Log in" }: EmailFormProps) {
	const {
		register,
		handleSubmit,
		formState: { errors },
	} = useForm<EmailFormData>({
		resolver: zodResolver(emailSchema),
		defaultValues: {
			email: defaultEmail || "",
		},
	});

	return (
		<form onSubmit={handleSubmit(onSubmit)}>
			<div className="space-y-4">
				<div className="relative">
					<Input label="Email" type="email" disabled={isLoading} error={errors.email?.message} {...register("email")} />
					{badge}
				</div>
				{error && <p className="text-sm text-red-500">{error}</p>}
				<div className="pt-4">
					<Button type="submit" disabled={isLoading} className="w-full">
						{isLoading ? "Sending..." : buttonLabel}
					</Button>
				</div>
			</div>
		</form>
	);
}
